import { CurrencyPipe } from '@angular/common';
import * as moment from 'moment-timezone';

export function getColumns(currencyPipe: CurrencyPipe) {
  return [
    {
      columnDef: 'id',
      header: 'ID',
      cell: (element: any) => `${element.id}`,
    },
    {
      columnDef: 'createdAt',
      header: 'Fecha creación',
      cell: (element: any) =>
        `${element.createdAt ? moment(new Date(element.createdAt), 'America/Santiago').format('lll') : ''}`,
    },
    {
      columnDef: 'fechaTermino',
      header: 'Fecha Término',
      cell: (element: any) =>
        `${element.fechaTermino ? moment(new Date(element.fechaTermino), 'America/Santiago').format('lll') : 'No aplica'}`,
    },
    {
      columnDef: 'operador',
      header: 'Completada por',
      cell: (element: any) =>
        `${element.emailOperador ? element.emailOperador : 'No aplica'}`,
    },

    {
      columnDef: 'clienteId',
      header: 'ID Cliente',
      cell: (element: any) => `${element.userId}`,
    },
    {
      columnDef: 'userId',
      header: 'Nombre usuario',
      cell: (element: any) =>
        `${element.usuario?.nombre || ''} ${element.usuario?.apellidos || ''}`,
    },
    {
      columnDef: 'cuentaTrabajo',
      header: 'Cajero de pago',
      cell: (element: any) =>
        element.cuentaTrabajo
          ? `${element.cuentaTrabajo.nombre} ${element.cuentaTrabajo.apellidos} - ${element.cuentaTrabajo.banco?.nombre || 'Sin banco'} - ${element.cuentaTrabajo.numeroCuenta}`
          : 'No aplica',
    },
    {
      columnDef: 'cuentaBeneficiarioId',
      header: 'Beneficiario',
      cell: (element: any) => {
        const cb = element.cuentaBeneficiario;
        return cb
          ? `${cb.nombre} ${cb.apellidos} | ${cb.numeroCuenta} | ${cb.tipoCuenta?.nombre || ''}`
          : 'No aplica';
      },
    },
    {
      columnDef: 'ruta',
      header: 'Ruta',
      cell: (element: any) => `${element.paisOrigen} - ${element.paisDestino}`,
    },
    {
      columnDef: 'tipoTransaccion',
      header: 'Tipo Transacción',
      cell: (element: any) => `${element.tipoTransaccion || ''}`,
    },
    {
      columnDef: 'totalMonedaOrigen',
      header: 'Monto origen',
      cell: (element: any) =>
        currencyPipe.transform(element.totalMonedaOrigen, '$'),
    },
    {
      columnDef: 'totalMonedaDestino',
      header: 'Monto destino',
      cell: (element: any) =>
        currencyPipe.transform(element.totalMonedaDestino, '$'),
    },
    {
      columnDef: 'bancoDestino',
      header: 'Banco destino',
      cell: (element: any) =>
        `${element.cuentaBeneficiario?.banco?.nombre || 'Sin banco'}`,
    },
    {
      columnDef: 'estado',
      header: 'Estado',
      cell: (element: any) =>
        `${element.estado?.replaceAll('_', ' ') || 'Sin estado'}`,
    },
  ];
}

export const columns = [
  {
    columnDef: 'id',
    header: 'ID',
    cell: (element: any) => `${element.id}`,
  },
  {
    columnDef: 'createdAt',
    header: 'Fecha creación',
    cell: (element: any) =>
      `${element.createdAt ? moment(new Date(element.createdAt), 'America/Santiago').format('lll') : ''}`,
  },
  {
    columnDef: 'fechaTermino',
    header: 'Fecha Término',
    cell: (element: any) =>
      `${element.fechaTermino ? moment(new Date(element.fechaTermino), 'America/Santiago').format('lll') : 'No aplica'}`,
  },
  {
    columnDef: 'operador',
    header: 'Operador',
    cell: (element: any) =>
      `${element.emailOperador ? element.emailOperador : 'No aplica'}`,
  },

  {
    columnDef: 'clienteId',
    header: 'ID Cliente',
    cell: (element: any) => `${element.userId}`,
  },
  {
    columnDef: 'userId',
    header: 'Nombre usuario',
    cell: (element: any) =>
      `${element.usuario?.nombre || ''} ${element.usuario?.apellidos || ''}`,
  },
  {
    columnDef: 'cuentaTrabajo',
    header: 'Cajero de pago',
    cell: (element: any) =>
      element.cuentaTrabajo
        ? `${element.cuentaTrabajo.nombre} ${element.cuentaTrabajo.apellidos} - ${element.cuentaTrabajo.banco?.nombre || 'Sin banco'} - ${element.cuentaTrabajo.numeroCuenta}`
        : 'No aplica',
  },
  {
    columnDef: 'cuentaBeneficiarioId',
    header: 'Beneficiario',
    cell: (element: any) => {
      const cb = element.cuentaBeneficiario;
      return cb
        ? `${cb.nombre} ${cb.apellidos} | ${cb.numeroCuenta} | ${cb.tipoCuenta?.nombre || ''}`
        : 'No aplica';
    },
  },
  {
    columnDef: 'ruta',
    header: 'Ruta',
    cell: (element: any) => `${element.paisOrigen} - ${element.paisDestino}`,
  },
  {
    columnDef: 'tipoTransaccion',
    header: 'Tipo Transacción',
    cell: (element: any) => `${element.tipoTransaccion || ''}`,
  },
  {
    columnDef: 'totalMonedaOrigen',
    header: 'Monto origen',
    cell: (element: any) => `${element.totalMonedaOrigen}`,
  },
  {
    columnDef: 'totalMonedaDestino',
    header: 'Monto destino',
    cell: (element: any) => `${element.totalMonedaDestino}`,
  },
  {
    columnDef: 'bancoDestino',
    header: 'Banco destino',
    cell: (element: any) =>
      `${element.cuentaBeneficiario?.banco?.nombre || 'Sin banco'}`,
  },
  {
    columnDef: 'estado',
    header: 'Estado',
    cell: (element: any) =>
      `${element.estado?.replaceAll('_', ' ') || 'Sin estado'}`,
  },
];

export const displayedColumns: string[] = [
  'id',
  'createdAt',
  'fechaTermino',
  'userId',
  'operador',
  'cuentaTrabajo',
  'cuentaBeneficiarioId',
  'ruta',
  'tipoTransaccion',
  'bancoDestino',
  'totalMonedaOrigen',
  'totalMonedaDestino',
  'tasa',
  'estado',
];
